<div class="notices-item-icon">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    *ngIf="notice.value.kind === 'error'"
  >
    <circle cx="12" cy="12" r="11.25" fill="#FDEDEB" stroke="#FF3B39" stroke-width="1.5" />
    <path
      fill="#FF3B39"
      d="M10.5 16.5c0-.398.158-.78.438-1.06.28-.282.66-.44 1.057-.44h.01c.397 0 .777.158 1.057.44A1.503 1.503 0 0 1 12.005 18h-.01c-.397 0-.777-.158-1.057-.44a1.503 1.503 0 0 1-.438-1.06Zm2.616-9.375A1.127 1.127 0 0 0 11.995 6a1.12 1.12 0 0 0-1.121 1.125v5.25a1.127 1.127 0 0 0 1.12 1.125 1.12 1.12 0 0 0 1.122-1.125v-5.25Z"
    />
  </svg>
</div>
<div
  class="notices-item-text"
  [class.notices-item-text-error]="
      notice.value.kind === 'error'
    "
>
  {{ notice.value.data }}
</div>
<div class="notices-item-close" (click)="onDelete(); (false)">
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 10 10">
    <path stroke="#2F3335" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 1 1 9M1 1l8 8" />
  </svg>
</div>
